import { breakpoints } from "@breuni-ui/nui/dist/design-tokens/json/breakpoints.json" with { type: "json" };

const breakpointM = `(max-width: ${breakpoints.m})`;

export const isBelowBreakpointM: () => boolean = () =>
  window.matchMedia(breakpointM).matches;
